import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "bca-usp-block",
  templateUrl: "usp-block.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UspBlockComponent {
  items$: Observable<string[]> = this._translate.get("RECEIPT.USP_BLOCK.ITEMS").pipe(
    map((result) => (Array.isArray(result) ? result : []))
  );

  constructor(private _translate: TranslateService) {}
}